{
  "sv": {
    "js": {
      "components": {
        "action_suggestion_modal": {
          "suggestion": "Åtgärdsförslag"
        },
        "actions_dropdown": {
          "more_options": "Fler alternativ",
          "open_menu": "Öppna meny"
        },
        "analysis_page": {
          "benchmark_base_tooltip": "En genomsnittlig fastighet i Planima har %{benchmark} per m² i underhållsskuld.",
          "building": "byggnad",
          "by_action_type": "Utgiftstyp och år",
          "by_budget_excluding_vat": "Budgeterat per år (exkl. moms)",
          "by_budget_including_vat": "Budgeterat per år (inkl. moms)",
          "by_category": "Kategori och år",
          "by_savings": "Energibesparing (kr) och år",
          "category": "kategori",
          "cost_kpi_title": "Utgift",
          "cost_kpi_tooltip": "Utgift för alla valda åtgärder",
          "facility": "fastighet",
          "graph_header": "Utgifter per år",
          "graph_header_savings": "Besparingar per år",
          "higher_value": "Detta värde är %{percentage}% högre.",
          "investment": "Investering",
          "lower_value": "Detta värde är %{percentage}% lägre.",
          "maintenance": "Underhåll",
          "maintenance_debt": "Underhållsskuld",
          "maintenance_debt_tooltip": "Utgifter för underhållsåtgärder som är eftersatta, akuta samt ej genomförda åtgärder tidigare än i år",
          "misc": "Övrigt",
          "multiple_facilities": "fastigheternas",
          "one_facility": "fastighetens",
          "per_area": "per m²",
          "per_year": "per år",
          "per_year_and_area": "per år och m²",
          "previous_savings_info": "Kan även visa besparingar från åtgärder som genomförts eller planerats tidigare, men endast om deras besparingsintervall överlappar den filtrerade perioden.",
          "status": "status",
          "tooltip_info": "%{base}. För beräkningar baserade på m² används %{facility_string} sammanlagda yta (BOA+LOA).",
          "total_electricity_savings": "El",
          "total_energy_savings": "Energibesparingar i kr",
          "total_heating_savings": "Värme"
        },
        "analysis_pie_chart": {
          "title": "Utgift per %{name}"
        },
        "attachment_dropzone": {
          "allowed_extensions_text": "Tillåtna filtyper: %{extensions}",
          "dropzone_text": "Dra filer hit eller klicka för att ladda upp (max %{max} MB)",
          "error": "Ett fel uppstod vid uppladdningen.",
          "heic_converted_notice": "Bilder i HEIC-format har konverterats till JPEG för att kunna visas i webbläsaren",
          "invalid_file_notice": "Du försökte ladda upp en ogiltig fil.",
          "rejected_file_notice": "Filer får inte vara större än %{max_size} MB",
          "success_message": "%{successful} av %{total} filer laddades upp.",
          "success_notice": "Uppladdningen är klar!",
          "too_many_files_notice": "Du kan ladda upp högst %{max_files} filer samtidigt.",
          "upload_count": "%{completed} av %{total} filer uppladdade...",
          "uploading": "Laddar upp..."
        },
        "attachment_list": {
          "confirm_delete": "Är du säker på att du vill ta bort filen?",
          "file_size": "Filstorlek",
          "name": "Namn",
          "user_email": "Uppladdat av"
        },
        "attachment_view": {
          "removed_file": "Filen har tagits bort."
        },
        "building_graphs": {
          "by_action_type": "Utgiftstyp och år",
          "by_energy_savings_in_kr": "Energibesparing (kr) och år",
          "by_energy_savings_in_kwh": "Energibesparing (kWh) och år",
          "previous_savings_info": "Visar även årliga besparingar från tidigare åtgärder vars energibesparande effekt sträcker sig in i den valda tidsperioden."
        },
        "chart_selector": {
          "choose_graph": "Välj graf:"
        },
        "climate_risks_bar_chart": {
          "empty_graph": "Grafen innehåller ingen data",
          "label": {
            "high": "Hög risk",
            "medium": "Medelhög risk"
          },
          "tooltip": {
            "facilities": {
              "one": "1 fastighet",
              "other": "%{count} fastigheter"
            },
            "total_facilities": {
              "one": "Totalt: 1 fastighet",
              "other": "Totalt: %{count} fastigheter"
            }
          }
        },
        "combobox": {
          "create_new": "Lägg till \"%{value}\"",
          "deselect_all": "Avmarkera alla",
          "deselect_visible": "Avmarkera synliga",
          "hidden_selected": "%{count} fler valda",
          "new_items_group": "Nya poster",
          "no_results": "Inga resultat hittades",
          "remove": "Ta bort",
          "select_all": "Markera alla",
          "select_all_summary": "%{selected} av %{total} valda",
          "select_visible": "Markera synliga"
        },
        "complete_action_modal": {
          "budget_label": "Budget",
          "budget_moved_notice": "Om du genomför åtgärden kommer den att flyttas till %{year} och tas bort från budgeten %{budget_name}",
          "budget_no_budgets_for_year": "Det finns inga budgetar för det valda året",
          "budget_placeholder": "Välj budget",
          "comment": "Kommentar",
          "comment_info": "Exempelvis vem som utförde åtgärden, vilka produkter/fabrikat som användes eller annan information som inte framgår av åtgärden.",
          "complete_action": "Genomför åtgärd",
          "completed_year": "Genomfördes år",
          "current_year": "Nuvarande år:",
          "excluding_vat": "exkl. moms.",
          "final_cost": "Faktiskt pris (exkl. moms)",
          "info": "Ange information om den genomförda åtgärden. Detta kan vara väldigt värdefullt för framtida planering, så försök få med så mycket som möjligt!",
          "planned_cost": "Planerat pris:",
          "planned_year": "Planerat år:"
        },
        "deposition_analysis": {
          "balance_current": "Fondsaldo vid nuvarande avsättning",
          "balance_recommended": "Fondsaldo vid rekommenderad avsättning",
          "current_deposition": "Nuvarande avsättning per år och m² (BOA)",
          "info": "Avsättningsanalysen visar <strong>hela din underhållsplan</strong> och <strong>exkluderar investeringsåtgärder</strong>. Eventuella filter som ställts in påverkar inte analysen.",
          "not_defined": "Ange BOA och avsättning",
          "recommended_deposition": "Rekommenderad avsättning per år och m² (BOA)",
          "title": "Avsättningsanalys"
        },
        "deposition_settings": {
          "balance": "Saldo",
          "current_balance": "Saldo i underhållsfond vid inledningen av år %{year}",
          "current_deposition": "Nuvarande avsättning",
          "current_yearly_deposition": "Nuvarande avsättning per år",
          "info": "Detta värde sätts manuellt, vanligtvis av den som levererar underhållsplanen. Om ni inte har en leverantör så kan ni antingen ange ett eget avsättningsmål eller bortse från detta fält.",
          "recommended_deposition": "Rekommenderad avsättning",
          "recommended_yearly_deposition": "Rekommenderad avsättning per år",
          "update": "Uppdatera"
        },
        "dialog": {
          "close": "Stäng"
        },
        "drawer": {
          "close": "Stäng",
          "unsaved_changes_confirm": "Ändringarna har inte sparats. Om du stänger nu försvinner det du har ändrat."
        },
        "error_boundary": {
          "contact_us": "Försök ladda om sidan eller kontakta vår support om problemet kvarstår.",
          "message": "Innehållet kunde inte visas på grund av ett oväntat fel.",
          "reload": "Ladda om sidan",
          "title": "Något gick fel"
        },
        "facilities_page_analysis": {
          "by_action_type": "Utgiftstyp och år",
          "by_facilities": "Fastighet och år",
          "by_savings": "Energibesparing (kr) och år",
          "by_tags": "Tagg och år",
          "missing": "Saknas",
          "previous_savings_info": "Kan även visa besparingar från åtgärder som genomförts eller planerats tidigare, men endast om deras besparingsintervall överlappar den filtrerade perioden."
        },
        "facilities_sustainability_pie_chart": {
          "building": "byggnad",
          "buildings": "byggnader"
        },
        "facility_part_list": {
          "amount": "Antal",
          "name": "Benämning",
          "unit": "Enhet"
        },
        "facility_part_modal": {
          "close": "Tillbaka",
          "title": "Mängdförteckning"
        },
        "list_items_per_page_selection": {
          "rows": "Antal rader"
        },
        "list_settings": {
          "search": "Sök..."
        },
        "list_table": {
          "filter_label": "Sök här...",
          "page_info": "Visar %{from} till %{to} av totalt %{total} rader",
          "page_size_label": "Antal rader"
        },
        "magic_link_generator": {
          "confirm": "Är du säker? Det finns en gammal länk som kommer att bli ogiltig.",
          "copy_to_clipboard": "Kopiera till urklipp",
          "error": "Något gick fel. Prova att ladda om sidan.",
          "resubmit": "Generera om",
          "submit": "Generera"
        },
        "maintenance_plan_select": {
          "facility": "Fastighet",
          "facility_tag": "Fastighetstagg",
          "more": "fler",
          "no_results": "Inga resultat",
          "organization": "Organisation",
          "prompt": "Sök på fastighet, fastighetstagg eller organisation..."
        },
        "modal": {
          "close": "Stäng"
        },
        "pagination_controls": {
          "next": "Nästa",
          "previous": "Föregående"
        },
        "pagination_info": {
          "info": "Visar %{from} till %{to} av totalt %{total} rader"
        },
        "panel": {
          "hide": "Dölj",
          "show": "Visa"
        },
        "puts": {
          "dropdown_menu": {
            "open_menu": "Öppna meny"
          },
          "pagination": {
            "next_page": "Nästa sida",
            "page": "Sida %{page}",
            "previous_page": "Föregående sida"
          },
          "spinner": {
            "loading": "Laddar…"
          },
          "tabs": {
            "more_tabs": "Fler flikar"
          }
        },
        "rails_filter_multi_select": {
          "all_selected": "Alla valda",
          "search": "Sök",
          "select_all": "Välj alla",
          "select_some": "Välj %{item}"
        },
        "status_picker": {
          "unchanged": "Oförändrad",
          "unknown": "Okänd status"
        },
        "suggestion_list": {
          "built_in_suggestion": "Planima-priser™",
          "contact_us": "Kontakta vår support så berättar vi mer!",
          "emission": "Utsläpp",
          "energy_saving": "Energibesparande",
          "feedback": "skicka in ett önskemål genom vårt formulär!",
          "name": "Namn",
          "repeated": "Intervall",
          "show_more": "Vill du se hela innehållet eller lägga till egna åtgärder?",
          "suggestion_info_1": "Listan inkluderar förslag från",
          "suggestion_info_2": ", en smart prislista för underhåll. Om du tycker att någonting saknas i Planima-priser™ så får du gärna",
          "suggestion_info_3": "För dig med mer avancerade behov går det även att själv skapa och redigera åtgärdsförslag -",
          "suggestions_info_title": "Saknar du någonting?",
          "trial_account_info_1": "Du tittar på ett urval av åtgärder från",
          "trial_account_info_2": ", vår omfattande prisdatabas för underhåll. I den riktiga versionen finns över 1300 åtgärder med tillhörande kostnader, klimatpåverkan (CO₂) och rekommenderade intervall.",
          "trial_account_info_title": "Exempellista från Planima-priser™",
          "unit": "Enhet",
          "unit_price": "Styckpris"
        },
        "sustainability_page": {
          "by_energy_savings": "Energibesparing (kWh) och år",
          "by_yearly_emissions": "Utsläpp och år",
          "emission_calculation_info": "Rapporterade utsläpp för åtgärder är inom <strong>Scope 3</strong> (embodied emissions). Beräkningsmetodik följer GHG-protokollet, specifikt <strong>Sector Supplement for Measuring and Accounting for Embodied Emissions in the Built Environment</strong>. Utsläppsdata hämtas från industridatabaser (ex. Boverkets Klimatdatabas), och EPD:er"
        },
        "time_bar_chart": {
          "title": "Underhållsskuld"
        },
        "toast": {
          "close": "Stäng"
        }
      },
      "config": {
        "tom_select": {
          "add_item": "Lägg till",
          "no_results": "Inga resultat hittades"
        }
      },
      "confirm_delete_modal": {
        "case_app_customer": "den arkiverad tillsammans med dess organisationer, fastigheter och underhållsplaner. Dess användare tas bort och kan bara delvis återställas.",
        "case_building": "byggnaden, dess energiklass och dess kopplade komponenter permanent borttagna.",
        "case_category": "den borttagen och åtgärder kopplade till kategorin kommer att bli okategoriserade men finnas kvar. Detta gäller även åtgärder i inaktiva underhållsplaner.",
        "case_component_with_actions": "den permanent borttagen. För komponentens %{count} kopplade åtgärder kommer bara kopplingen att tas bort, åtgärderna finns kvar.",
        "case_component_without_actions": "den permanent borttagen.",
        "case_facility": "den och dess underhållsplaner permanent borttagna.",
        "case_mass_edit": "de och deras eventuella upprepningar permanent borttagna.",
        "case_organization": "den och dess fastigheter samt underhållsplaner permanent borttagna.",
        "default": "den permanent borttagen."
      },
      "data_tables": {
        "aria": {
          "sort_ascending": ": aktivera för att sortera kolumnen i stigande ordning",
          "sort_descending": ": aktivera för att sortera kolumnen i fallande ordning"
        },
        "empty_table": "Tabellen innehåller ingen data",
        "info": "Visar _START_ till _END_ av totalt _TOTAL_ rader",
        "info_empty": "Visar 0 till 0 av totalt 0 rader",
        "info_filtered": "(filtrerade från totalt _MAX_ rader)",
        "length_menu": "Visa _MENU_ rader",
        "loading_records": "Laddar...",
        "paginate": {
          "first": "Första",
          "last": "Sista",
          "next": "Nästa",
          "previous": "Föregående"
        },
        "processing": "Bearbetar...",
        "search": "Sök:",
        "zero_records": "Hittade inga matchande resultat"
      },
      "form": {
        "buttons": {
          "cancel": "Avbryt",
          "save": "Spara"
        },
        "labels": {
          "address": "Adress",
          "app_customer": "Kund",
          "name": "Namn",
          "organization": "Organisation",
          "region": "Postort",
          "year_of_construction": "Byggår",
          "zip_code": "Postnummer"
        }
      },
      "helpers": {
        "budget": {
          "amount_label": {
            "excluding_vat": "Budgetram (exkl. moms)",
            "including_vat": "Budgetram (inkl. moms)"
          },
          "amount_tooltip": "Momsinställning för budget görs på kontonivå",
          "name_label": "Namn på budget",
          "name_placeholder": "T.ex. Underhållsbudget"
        },
        "currency": "kr",
        "delete": "Ta bort",
        "download": "Ladda ner",
        "emission_unit": "kg CO₂e",
        "energy_unit": "kWh",
        "maintenance_plan_action": {
          "build_diff": {
            "indexation": "uppdatera basår för indexuppräkning till innevarande år",
            "remove_field_html": "ta bort <strong>%{translated_key}</strong>",
            "update_field_html": "uppdatera <strong>%{translated_key} till %{value}</strong>"
          },
          "changes": "Om du klickar på knappen nedan kommer vi att %{changes} samt spara åtgärden.",
          "diff_from_suggestion": "Den här åtgärden har inte samma information som det åtgärdsförslag den följer. Vill du uppdatera den här åtgärden så att den överensstämmer med åtgärdsförslaget \"%{suggestion_name}\"?",
          "fields": {
            "carbon_dioxide_equivalent": "utsläpp per enhet",
            "is_energy_saving": "energibesparande",
            "repeated": "intervall",
            "unit": "enhet",
            "unit_price": "styckpris"
          },
          "sync_action_submit": "Uppdatera åtgärd"
        },
        "no": "Nej",
        "planima_price": "Planima-pris",
        "removed_user": "Borttagen användare",
        "year": "År",
        "yes": "Ja"
      },
      "lib": {
        "chart_helpers": {
          "energy_savings": "Energibesparing",
          "investment": "Investering",
          "maintenance": "Underhåll",
          "misc": "Okategoriserat",
          "total": "Totalt"
        },
        "maintenance_plan_action": {
          "status_options": {
            "completed": "Genomförd",
            "decided": "Beslutad",
            "deferred": "Eftersatt",
            "draft": "Utkast",
            "in_progress": "Pågående",
            "inactive": "Vilande",
            "planned": "Planerad",
            "prioritized": "Akut"
          }
        }
      },
      "pages": {
        "account": {
          "budget_settings": {
            "form": {
              "budget_change_notice": "Det finns minst en budget på kontot. De inmatade beloppen i budgetarna ändras inte.",
              "excl_vat": "Exkl. moms",
              "incl_vat": "Inkl. moms",
              "info": "Här väljer du om budgetramar anges inklusive eller exklusive moms. Inställningen gäller alla budgetar på kontot, och ändrar aldrig de belopp som redan är inlagda.",
              "vat_basis_label": "Momsbas"
            }
          }
        },
        "facilities": {
          "buildings": {
            "form": {
              "building_definition": "En byggnad är en huskropp på den juridiska fastigheten och används för att gruppera ihop åtgärder i underhållsplanen."
            }
          },
          "moves": {
            "form": {
              "edit_link": "Redigera fastigheten",
              "info": "Fastigheten flyttas till en annan organisation, vilket kan ändra vilka användare som har åtkomst",
              "other_errors": "Fastigheten kunde inte flyttas på grund av ett fel på ett annat fält. Redigera fastigheten för att se och åtgärda det.",
              "placeholder": "Välj organisation",
              "submit": "Flytta"
            }
          }
        },
        "organizations": {
          "form": {
            "app_customer": {
              "info": "OBS! Om organisationens kundtillhörighet ändras så tappar föregående kunds användare behörighet till organisationen och dess fastigheter.",
              "label": "Kund",
              "placeholder": "Välj kundkonto"
            },
            "logo": {
              "delete": "Ta bort bild",
              "delete_confirm": "Är du säker?",
              "help_text": "Spara med er standardlogotyp, eller välj en anpassad bild ovan.",
              "label": "Logotyp"
            },
            "name": {
              "help_text": "Kan exempelvis vara bolags-, kund- eller förvaltarnamn beroende på indelning.",
              "label": "Namn"
            }
          },
          "moves": {
            "form": {
              "edit_link": "Redigera organisationen",
              "info": "Organisationen flyttas till det valda kundkontot. Det kan ändra vilka användare som har åtkomst. Kopplingar mellan åtgärderna och deras projekt, budgetar och anpassade åtgärdsförslag tas bort permanent och kan inte återställas.",
              "other_errors": "Organisationen kunde inte flyttas på grund av ett fel på ett annat fält. Redigera organisationen för att se och åtgärda det.",
              "placeholder": "Välj kundkonto",
              "submit": "Flytta"
            }
          }
        }
      },
      "stimulus_controllers": {
        "action_types_fallback": {
          "loading_error": "Förbättringsförslagen kunde tyvärr inte laddas på grund av ett tillfälligt fel hos en extern tjänst.",
          "try_again": "Försök igen senare eller uppdatera sidan."
        },
        "autocomplete": {
          "error": "Något gick fel! Ladda om sidan och försök igen."
        },
        "character_counter": {
          "approaching_limit": "Närmar sig teckengränsen"
        },
        "component_selection": {
          "remove_component": "Ta bort"
        },
        "google_maps": {
          "highest_risks": "Högsta risk(er)"
        },
        "tag_list": {
          "diverging": "olika"
        },
        "turbo_confirm": {
          "confirm_close": "Är du säker på att du vill stänga? Osparade ändringar kommer att gå förlorade."
        }
      },
      "text_helpers": {
        "join_words_to_sentence": {
          "last_word_connector": " och ",
          "last_word_connector_or": " eller ",
          "two_words_connector": " och ",
          "two_words_connector_or": " eller ",
          "words_connector": ", "
        }
      },
      "views": {
        "budgets": {
          "card": {
            "actions_count": {
              "one": "%{count} åtgärd",
              "other": "%{count} åtgärder"
            },
            "actual_expense": "Faktisk utgift",
            "available_amount": "Disponibelt",
            "deviation_percentage": "%{sign}%{value} %",
            "deviation_tooltip_over": "Faktisk utgift är %{amount} högre än planerad utgift",
            "deviation_tooltip_under": "Faktisk utgift är %{amount} lägre än planerad utgift",
            "draft_warning": "Budgeten innehåller åtgärder med status utkast och deras utgift räknas inte med.",
            "draft_warning_show_actions_label": "Visa åtgärder med status utkast",
            "forecast": "Prognos",
            "forecast_tooltip": "Summa av faktisk och kvarvarande planerad utgift",
            "menu": {
              "delete": "Ta bort budget",
              "edit": "Redigera"
            },
            "missing_final_cost_warning": "Budgeten innehåller genomförda åtgärder utan faktisk utgift.",
            "missing_final_cost_warning_show_actions_label": "Visa genomförda åtgärder utan faktisk utgift",
            "overage_amount": "Överskridning",
            "planned_expense": "Planerad utgift",
            "progress_bar_label": "Budgetförbrukning: %{consumed} av %{cap}",
            "remaining_planned_expense": "Kvarvarande planerat",
            "show_actions": "Visa åtgärder",
            "spending_cap_excluding_vat": "Budgeterat (exkl. moms)",
            "spending_cap_including_vat": "Budgeterat (inkl. moms)"
          },
          "delete_dialog": {
            "cancel": "Nej, avbryt",
            "confirm": "Ja, ta bort",
            "confirmation": {
              "one": " innehåller en åtgärd. Åtgärden tas inte bort, men budgeten kopplas bort från den.",
              "other": " innehåller %{count} åtgärder. Åtgärderna tas inte bort, men budgeten kopplas bort från dem.",
              "zero": " innehåller inga åtgärder."
            },
            "title": "Är du säker?"
          },
          "empty_state": {
            "text": "Det finns inga budgetar för %{year} än"
          },
          "export_menu": {
            "excel": "Exportera Excel",
            "excel_exporting": "Exporterar...",
            "excel_failed": "Kunde inte starta exporten",
            "pdf": "Exportera PDF",
            "pdf_exporting": "Exporterar...",
            "pdf_failed": "Kunde inte starta exporten"
          },
          "form": {
            "amount": {
              "help_text": {
                "remaining": "Kvarvarande planerad utgift för %{year}: %{amount} (%{vat_context})",
                "total": "Planerad utgift för %{year}: %{amount} (%{vat_context})"
              }
            },
            "cancel": "Avbryt",
            "display_name_preview": "Visas som: %{display_name}",
            "edit_title": "Redigera budget",
            "new_title": "Skapa ny budget",
            "save": "Skapa ny budget",
            "save_changes": "Uppdatera budget",
            "vat_context": {
              "excluding": "exkl. moms",
              "including": "inkl. moms"
            },
            "year_label": "Budgetår"
          },
          "heading": "Budget",
          "new_budget_button": "Ny budget",
          "panel": {
            "actions_guide": {
              "heading": "Så här kopplar du åtgärder till budgeten",
              "step_1": "Klicka på \"Lägg till åtgärder\" nedan för att öppna samordningsvyn, filtrerad på åtgärder utan budget för det här budgetåret",
              "step_2": "Filtrera fram åtgärderna du vill inkludera — t.ex. på fastighet, kategori eller år",
              "step_3": "Markera åtgärderna. Använd \"Markera alla\" i filterraden för att snabbt välja alla filtrerade",
              "step_4": "Klicka på \"Lägg till i budget\" i verktygsfältet längst ner och välj den här budgeten",
              "tip": "Tips - du kan också lägga till enskilda åtgärder via (…)-menyn direkt på åtgärden"
            },
            "add_actions_button": "Lägg till åtgärder",
            "breakdown": {
              "category_title": "Utgift per kategori",
              "empty_state": "Det finns ingen utgift att fördela än",
              "expense_type_title": "Utgift per utgiftstyp",
              "facility_title": "Utgift per fastighet",
              "status_title": "Utgift per status"
            },
            "export_button": "Exportera",
            "view_actions_button": "Se åtgärder"
          },
          "total_budget": "Total budget: %{amount}",
          "unbudgeted_actions_warning": {
            "show_actions_label": "Visa åtgärder utan budget",
            "text": {
              "one": "%{count} åtgärd till en planerad utgift av %{amount} ligger planerad för året men saknar budget.",
              "other": "%{count} åtgärder till en planerad utgift av %{amount} ligger planerade för året men saknar budget."
            }
          },
          "year_navigation": {
            "next_year": "Nästa år",
            "previous_year": "Föregående år"
          }
        },
        "complete_actions": {
          "edit": {
            "confirm_unlock": "Är du säker på att du vill låsa upp åtgärden?",
            "save": "Spara åtgärd",
            "unlock": "Lås upp",
            "unlock_explainer": "Du redigerar en genomförd åtgärd. Om åtgärden genomfördes av misstag kan du låsa upp den, men notera att åtgärden då tappar sin koppling till kommande upprepningar och sitt upprepningsintervall.",
            "unsaved_changes_leave_confirm": "Ändringarna har inte sparats. Om du lämnar sidan nu försvinner det du har ändrat.",
            "year_locked_by_budget": "Åtgärden tillhör budgeten %{budget} och kan inte byta år"
          }
        },
        "grouped_list": {
          "action_count": {
            "one": "(1 åtgärd)",
            "other": "(%{count} åtgärder)"
          },
          "actions_before_plan_start": {
            "one": "Det finns en åtgärd som inte är genomförd och har ett planerat år innan planens början.",
            "other": "Det finns %{count} åtgärder som inte är genomförda och har ett planerat år innan planens början."
          },
          "actions_before_plan_start_change_filter": "Du kan %{link}.",
          "actions_before_plan_start_link": "ändra filtret för att visa och planera om dessa åtgärder",
          "actions_table": {
            "expense_distribution_tooltip": {
              "investment": "Investering, %{pct}%",
              "maintenance": "Underhåll, %{pct}%"
            },
            "headers": {
              "action": "Åtgärd",
              "actual_expense": "Faktisk utgift",
              "budget": "Budget",
              "building": "Byggnad",
              "category": "Kategori",
              "component": "Komponent",
              "excl_vat": "(exkl. moms)",
              "expense_distribution": "Utgiftsfördelning",
              "facility": "Fastighet",
              "incl_vat": "(inkl. moms)",
              "interval": "Intervall",
              "location": "Läge",
              "organization": "Organisation",
              "planned_expense": "Planerad utgift",
              "previous_year": "Föreg. år",
              "project": "Projekt",
              "quantity": "Mängd",
              "status": "Status",
              "tags": "Märkning",
              "total_emission": "Totalt utsläpp",
              "unit_price": "Styckpris",
              "year": "År"
            },
            "icon_tooltips": {
              "attachments": "Bifogade filer",
              "comments": "%{count} kommentarer",
              "energy_saving": "Energibesparande",
              "over_budget": "Budgeten är överskriden",
              "project": "Kopplad till projekt",
              "suggestion": "Kopplad till åtgärdsförslag"
            },
            "interval_years": "%{count} år",
            "investment": "Investering",
            "maintenance": "Underhåll",
            "menu": {
              "add_to_budget": "Lägg till i budget",
              "add_to_project": "Lägg till i projekt",
              "column_header": "Åtgärdsmeny",
              "complete": "Genomför åtgärd",
              "copy": "Kopiera",
              "delete": "Ta bort",
              "delete_confirmation": "Är du säker på att du vill ta bort den här åtgärden?",
              "edit": "Redigera",
              "edit_project": "Redigera projekt",
              "open_in_new_tab": "Öppna i ny flik",
              "save": "Spara",
              "show": "Visa"
            },
            "preliminary_emission": "Preliminärt",
            "preliminary_price": "Preliminärt",
            "price_tooltip": {
              "admin_rate": "Byggherrekostnader",
              "amount": "Antal",
              "indexation_rate": "Indexering",
              "unit_price": "Styckpris",
              "vat_rate": "Momssats"
            },
            "select_action": "Välj åtgärd",
            "select_all_actions": "Välj alla åtgärder",
            "status_change_failed": "Statusen kunde inte uppdateras. Försök igen."
          },
          "budget_assignment_dialog": {
            "all_already_in_budget": {
              "one": "Åtgärden ingår redan i den här budgeten",
              "other": "Alla %{count} åtgärder ingår redan i den här budgeten"
            },
            "already_in_budget": "%{count} av %{total} åtgärder ingår redan i den här budgeten",
            "assignment_mode_label": "Hur ska åtgärderna läggas till?",
            "available_amount": "Disponibelt",
            "budget_placeholder": "Välj en budget",
            "cancel": "Avbryt",
            "conflicts": {
              "one": "%{count} åtgärd tillhör redan en annan budget",
              "other": "%{count} åtgärder tillhör redan en annan budget"
            },
            "draft_notice": "%{count} av åtgärderna är utkast. Deras utgift räknas inte med i budgeten förrän statusen ändras.",
            "error_general": "Något gick fel. Försök igen.",
            "existing_budget_option": "Lägg till i befintlig budget",
            "move_conflicting": "Flytta dessa från annan budget",
            "new_budget_option": "Skapa ny budget",
            "new_budget_planned_expense_help": "Planerad utgift för valda åtgärder: %{amount} %{vat_suffix}",
            "no_budget_for_year_notice": "Det finns ingen budget för %{year}. Be en administratör att skapa en budget för året.",
            "overage_amount": "Överskriden med %{amount}",
            "overspend_warning": "Budgetram kommer att överskridas med %{amount}",
            "pending_amount": "%{amount} tillkommer i budgeten %{vat_suffix}",
            "save": {
              "one": "Lägg till %{count} åtgärd i budget",
              "other": "Lägg till %{count} åtgärder i budget"
            },
            "summary": {
              "one": "%{count} åtgärd med planerad utgift på %{amount} %{vat_suffix}",
              "other": "%{count} åtgärder med planerad utgift på %{amount} %{vat_suffix}"
            },
            "switch_title": "Byt budget",
            "title": "Lägg till i budget",
            "vat_suffix": {
              "excluding": "(exkl. moms)",
              "including": "(inkl. moms)"
            }
          },
          "budget_badge": {
            "excl_vat": "(exkl. moms)",
            "incl_vat": "(inkl. moms)",
            "over_budget": "Över budget: %{amount}",
            "remaining": "Kvar av budget: %{amount}"
          },
          "column_menu": {
            "drag_handle_label": "Ändra ordning för %{column}"
          },
          "columns_button": "Kolumner (%{count})",
          "delete_saved_filter_dialog": {
            "body": "Är du säker på att du vill ta bort filtret \"%{name}\"?",
            "cancel": "Nej, avbryt",
            "confirm": "Ja, ta bort",
            "title": "Ta bort sparat filter"
          },
          "filters": {
            "badge_range": "%{from}–%{to}",
            "badge_range_currency": "%{from}–%{to} kr",
            "budget": {
              "label": "Budget"
            },
            "building": {
              "label": "Byggnad"
            },
            "category_name": {
              "label": "Kategori"
            },
            "clear_button": "Rensa filter",
            "close_button": "Stäng filter",
            "connected_to_suggestion": {
              "label": "Kopplad till Planima-pris"
            },
            "dismiss_filter": "Ta bort %{label}",
            "empty": "Inga åtgärder hittades",
            "facility_component": {
              "label": "Komponent"
            },
            "investment_rate": {
              "label": "Utgiftstyp"
            },
            "is_energy_saving": {
              "label": "Energibesparande"
            },
            "location": {
              "label": "Läge"
            },
            "maintenance_plan_selection_list": {
              "label": "Underhållsplan"
            },
            "more_badges": "... och %{count} till",
            "plan_selection_list": {
              "label": "Fastighet/Organisation"
            },
            "project": {
              "label": "Projekt"
            },
            "range_invalid": "Värdet är för lågt",
            "save_filter_button": "Spara filter",
            "saved_filters_button": "Sparade filter",
            "status": {
              "label": "Status"
            },
            "tag_ids": {
              "label": "Märkning"
            },
            "title": "Filter",
            "total_price": {
              "field_label": "Planerad utgift (från - till)",
              "from_placeholder": "Från (kr)",
              "label": "Planerad utgift",
              "to_placeholder": "Till (kr)"
            },
            "vat_rate": {
              "label": "Momssats"
            },
            "year": {
              "field_label": "År (från - till)",
              "from_placeholder": "Från",
              "label": "År",
              "to_placeholder": "Till"
            },
            "year_badge": "År: %{from}–%{to}",
            "year_from_placeholder": "Från",
            "year_label": "År (från - till)",
            "year_to_placeholder": "Till"
          },
          "floating_bar": {
            "add_to_budget": "Lägg till i budget",
            "add_to_budget_disabled_tooltip": {
              "mixed_years": "De markerade åtgärderna har olika planerade år.",
              "no_budget_for_year": "Det finns ingen budget för %{year}",
              "too_many_actions": "Du kan inte lägga till fler än 1000 åtgärder i en budget samtidigt."
            },
            "close": "Stäng",
            "copy": "Kopiera",
            "delete": "Ta bort",
            "edit": "Redigera",
            "mass_copy_disabled_tooltip": "Du kan inte kopiera fler än 1000 åtgärder samtidigt.",
            "mass_delete_disabled_tooltip": "Du kan inte ta bort fler än 1000 åtgärder samtidigt.",
            "mass_edit_disabled_tooltip": "Du kan inte redigera fler än 1000 åtgärder samtidigt.",
            "select_all": "Markera alla",
            "selected": {
              "one": "1 vald åtgärd",
              "other": "%{count} valda åtgärder"
            }
          },
          "generate_actions": "Generera åtgärder",
          "group_actions_failed": "Åtgärderna i gruppen kunde inte laddas",
          "group_costs": {
            "actual": "Faktisk:",
            "planned": "Planerad:"
          },
          "grouping": {
            "main_group": "Huvudgrupp",
            "options": {
              "action": "Åtgärd",
              "budget": "Budget",
              "building": "Byggnad",
              "category": "Kategori",
              "component": "Komponent",
              "facility": "Fastighet",
              "location": "Läge",
              "none": "Ingen grupp",
              "project": "Projekt",
              "year": "År"
            },
            "sub_group": "Undergrupp"
          },
          "groups_collapse_mode": {
            "collapsed": "Ihopfällda grupper",
            "expanded": "Utfällda grupper",
            "label": "Visningsläge för grupper"
          },
          "include_vat": "Inkludera moms",
          "loading": "Laddar åtgärder...",
          "new_action": "Ny åtgärd",
          "new_action_in_group": "Ny åtgärd i %{group}",
          "project_dialog": {
            "label": "Projekt",
            "placeholder": "Välj projekt"
          },
          "recalculating_plans": "Planima arbetar med att beräkna ditt underhåll, vilket kan ta någon minut. Det går inte att göra några ytterligare ändringar under tiden.",
          "recalculating_tooltip": "Det går inte att göra ändringar medan Planima beräknar ditt underhåll",
          "retry": "Försök igen",
          "save_filter_modal": {
            "name_empty": "Ange ett namn",
            "name_label": "Namn",
            "name_placeholder": "Ange ett filternamn",
            "name_taken": "Du har redan ett filter som heter “%{existingName}”",
            "name_too_long": "Namn får vara max %{count} tecken",
            "save": "Spara",
            "title": "Spara filter"
          },
          "saved_filters_dropdown": {
            "delete_aria_label": "Ta bort %{name}",
            "empty": "Inga sparade filter"
          },
          "search": {
            "clear": "Rensa sökning",
            "empty": "Inga åtgärder matchar din sökning",
            "placeholder": "Sök åtgärd eller märkning"
          },
          "settings": "Inställningar",
          "show_more_actions": "Visa fler (%{count} kvar)",
          "show_more_groups": "Visa fler grupper (%{count} kvar)",
          "show_more_groups_failed": "Fler grupper kunde inte laddas",
          "show_more_subgroups": "Visa fler undergrupper (%{count} kvar)",
          "show_repetitions": "Visa upprepningar",
          "subgroups_failed": "Undergrupperna kunde inte laddas",
          "title": "Samordning",
          "updating_list": "Hämtar åtgärder"
        },
        "maintenance_plan_actions": {
          "edit_title": "Redigera åtgärd",
          "form": {
            "action_checkindex": {
              "label": "Indexuppräkning?"
            },
            "action_name": {
              "label": "Åtgärdsnamn",
              "modal_trigger": "Välj från åtgärdsförslag",
              "tooltip": "Beskriv vad som ska göras och på vilken del av fastigheten. Exempel: 'Måla fasadpanel'"
            },
            "action_suggestion": {
              "no_results": "Din sökning gav inga resultat",
              "prompt": "Börja skriva för att få förslag på åtgärder!",
              "prompt_tip_html": "Tips! Sök på <em>vad du ska utföra åtgärden på</em> (t.ex. \"staket\") istället för <em>vilken aktivitet som ska utföras</em> (t.ex. \"måla\").",
              "show_all_results_html": "Visa alla resultat för \"%{query}\" (%{result_count} st)",
              "show_all_suggestions": "Visa alla åtgärdsförslag",
              "table_heads": {
                "emission": "Utsläpp",
                "name": "Namn",
                "repeated": "Intervall",
                "unit": "Enhet",
                "unit_price": "Styckpris"
              },
              "trial_account_info": "I provkonton visas endast ett urval av våra Planima-priser. Som kund hos oss får du tillgång till alla 1300 Planima-priser!"
            },
            "amount": {
              "choose_from_amounts": "Välj från mängdförteckning",
              "label": "Antal",
              "match": "Antal från:",
              "mismatch": "Antal avviker från:",
              "no_amount": "saknar antal",
              "tooltip": "Antalet av den angivna enheten som åtgärden ska utföras på. Exempel: Om det är 20 m2 fasadpanel som ska målas, ange 20."
            },
            "budget": {
              "choose_year_first": "Ange planerat år först",
              "label": "Budget",
              "no_budgets_for_year": "Det finns inga budgetar för det valda året",
              "placeholder": "Välj budget",
              "tooltip": "Kopplar åtgärden till en av budgetarna för det planerade året"
            },
            "building_name": {
              "label": "Byggnad",
              "placeholder": "Välj byggnad",
              "tooltip": "Byggnaden som åtgärden ska utföras på, i det fall fastigheten består av flera byggnader. Lämna tomt om den ska utföras på alla byggnader! Exempel: 'Skolgatan 23'"
            },
            "carbon_dioxide_equivalent": {
              "label": "Utsläpp per enhet",
              "tooltip": "Ange kg CO₂-ekvivalenter per enhet."
            },
            "category": {
              "label": "Kategori",
              "not_matching_component_category": "Kategori avviker från valda komponentens kategori: %{component_category}",
              "placeholder": "Välj kategori",
              "tooltip": "Kategori som åtgärden ska tillhöra, vilket används för att filtrera och gruppera åtgärder."
            },
            "comments": {
              "delete_confirmation": "Är du säker på att du vill ta bort kommentaren? Kommentaren tas bort permanent och kan inte återställas.",
              "delete_error": "Kommentaren kunde inte tas bort. Försök igen.",
              "empty": "Inga kommentarer än",
              "load_error": "Kommentarerna kunde inte hämtas. Försök igen.",
              "load_more": "Visa fler kommentarer",
              "mention_hint": "Skriv @ för att nämna någon",
              "new_comment_label": "Kommentar",
              "placeholder": "Skriv en kommentar…",
              "send": "Skicka",
              "send_error": "Kommentaren kunde inte skickas. Försök igen."
            },
            "component": {
              "clear": "Rensa komponentval",
              "component_is_created_on_save": "Komponenten skapas på byggnaden när du sparar",
              "group_other": "Övriga komponenter",
              "group_suggested": "Föreslagna komponenter",
              "label": "Komponent",
              "no_suggestions": "Inga komponentförslag hittades",
              "placeholder": "Välj komponent",
              "show_all_suggestions": "Visa alla komponentförslag",
              "tooltip": "Komponenten är en specifik del av fastigheten som åtgärden ska utföras på. Om komponenten tillhör en specifik byggnad måste det vara densamma som åtgärdens byggnad."
            },
            "component_suggestion": {
              "on_building": {
                "no": "Nej",
                "yes": "Ja"
              },
              "table_heads": {
                "amount": "Antal",
                "name": "Namn",
                "on_building": "Finns på vald byggnad",
                "unit": "Enhet"
              },
              "title": "Komponentförslag",
              "unspecified_building": "Ospecificerad byggnad"
            },
            "create_previously_completed": {
              "label": "Skapa genomförd åtgärd"
            },
            "description": {
              "label": "Beskrivning",
              "tooltip": "Kompletterande information om åtgärden."
            },
            "follow_suggestion": {
              "label": "Följ åtgärdsförslaget"
            },
            "headings": {
              "attachments": "Bilagor",
              "category_and_grouping": "Kategorisering & gruppering",
              "comments": "Kommentarer",
              "energy_and_sustainability": "Energi & hållbarhet",
              "misc": "Övrigt"
            },
            "indexation_starts_on_year": {
              "label": "Basår för indexering"
            },
            "investment_rate_selector": {
              "distribute_rate": "Fördela utgift",
              "investment": "Investering",
              "investment_rate": "Andel investering",
              "label": "Utgiftstyp",
              "maintenance": "Underhåll",
              "maintenance_rate": "Andel underhåll",
              "tooltip": "Anger om det är en underhållsåtgärd eller en investering. Det sistnämnda inkluderas t.ex. inte i underhållsskulden."
            },
            "is_energy_saving": {
              "description": "Den ekonomiska besparingen räknas ut baserat på fastighetens energipriser. Uppdatera el- och värmepris på sidan <a href=\"%{facility_about_path}\">Om fastigheten</a>. Energibesparingen visas lika länge som det valda intervallet, eller bara för det planerade året om inget intervall finns.",
              "description_no_link": "Den ekonomiska besparingen räknas ut baserat på fastighetens energipriser. Energibesparingen visas lika länge som det valda intervallet, eller bara för det planerade året om inget intervall finns.",
              "label": "Energibesparande?"
            },
            "location": {
              "label": "Läge",
              "placeholder": "Välj läge",
              "tooltip": "Läge anger en plats i fastigheten. Exempel: 'Trapphus' eller 'Tvättstuga'."
            },
            "maintenance_plan": {
              "choose_maintenance_plan_first": "Välj underhållsplan först",
              "label": "Underhållsplan",
              "placeholder": "Välj underhållsplan"
            },
            "previous_year": {
              "label": "Senast genomförd/uppförd"
            },
            "project": {
              "label": "Projekt",
              "placeholder": "Välj projekt",
              "tooltip": "Koppla åtgärden till ett projekt för att gruppera åtgärder som ska utföras tillsammans."
            },
            "repeated": {
              "label": "Intervall",
              "tooltip": "Antal år mellan att åtgärden kommer att upprepas. Exempel: En åtgärd planerad till 2022 med intervall 10 år kommer även planeras till år 2032, 2042, o.s.v."
            },
            "status": {
              "label": "Status",
              "placeholder": "Välj status",
              "tooltip": "Status på åtgärden, vilket används för att filtrera och gruppera åtgärder, samt för att beräkna underhållsskuld."
            },
            "submit": {
              "cancel": "Avbryt",
              "delete": "Ta bort åtgärd",
              "delete_confirmation": "Är du säker på att du vill ta bort åtgärden?",
              "save_and_add_more": "Spara och lägg till ny åtgärd",
              "save_as_draft": "Spara som utkast",
              "submit": "Spara åtgärd"
            },
            "suggestion": {
              "info_title": "Vad ingår i Planima-priset?"
            },
            "tags": {
              "label": "Märkning",
              "placeholder": "Skriv och välj märkning från listan",
              "tooltip": "Ange en eller flera valfria märkningar, vilka kan användas för att filtrera åtgärder. Exempel: projektnummer, åtgärdskod, ansvarig person"
            },
            "total_calculations": {
              "annual_savings": "Årlig besparing:",
              "payback_time": "Återbetalningstid:",
              "total_cost": "Totalt pris:",
              "total_cost_admin_rate": "byggherrekostnad (%{admin_rate}%)",
              "total_cost_excl_vat": "exkl. moms",
              "total_cost_incl_prefix": "inkl. ",
              "total_cost_incl_vat": "inkl. moms (%{vat_rate}%)",
              "total_cost_indexation_rate": "indexering (%{indexation_rate}%)",
              "total_emissions": "Totala utsläpp:"
            },
            "unit": {
              "label": "Enhet",
              "mismatch": "Enhet avviker från vald komponent (%{unit})",
              "tooltip": "Enheten för det antal som ska utföras. Exempel: Priset för att måla fasadpanel beror på antalet kvadratmeter, så ange 'm2'"
            },
            "unit_price": {
              "label": "Styckpris (exkl. moms)",
              "too_high_amount": "Priset för denna åtgärd är ovanligt högt. Kontrollera att antal och styckpriset är rimligt.",
              "tooltip": "Pris per enhet för att utföra åtgärden, inklusive både material- och arbetskostnader. Exempel: Pris per kvadratmeter för att måla av fasadpanel"
            },
            "vat_rate": {
              "custom_input_label": "Egen momssats",
              "label": "Momssats",
              "other": "Annat…",
              "placeholder": "Välj momssats",
              "tooltip": "Momssatsen som gäller för just den här åtgärden. Den påverkas inte om planens standardmoms ändras senare."
            },
            "year": {
              "label": "Planerat år",
              "recommendation": "Baserat på intervall bör planerat år vara"
            },
            "yearly_electricity_savings_kwh": {
              "label": "Total elbesparing per år",
              "tooltip": "Besparing i elförbrukning för hela åtgärden"
            },
            "yearly_heating_savings_kwh": {
              "label": "Total värmebesparing per år",
              "tooltip": "Besparing i värmeförbrukning för hela åtgärden"
            }
          },
          "new_title": "Skapa ny åtgärd",
          "page_unsaved_changes_confirm": "Ändringarna har inte sparats. Om du lämnar sidan nu försvinner det du har ändrat.",
          "show": {
            "amount_and_unit": "Antal / Enhet",
            "annual_energy_savings_kwh": "Årlig energibesparing (kWh)",
            "annual_energy_savings_sek": "Årlig energibesparing (kr)",
            "building": "Byggnad",
            "carbon_dioxide_equivalent_total": "Totalt utsläpp",
            "completed": "Genomfördes",
            "component": "Komponent",
            "electricity_savings_distribution": "Fördelning besparing el",
            "energy_saving_no": "Nej",
            "energy_saving_yes": "Ja",
            "facility": "Fastighet",
            "final_cost_excl_vat": "Faktiskt pris (exkl. moms)",
            "final_cost_incl_vat": "Faktiskt pris (inkl. moms %{vat_percentage}%)",
            "heat_savings_distribution": "Fördelning besparing värme",
            "maintenance_plan": "Underhållsplan",
            "no_files": "Inga filer bifogade",
            "payback_time": "Återbetalningstid",
            "payback_time_tooltip": "Baseras på totalt pris och årlig energibesparing",
            "planned": "Planerad",
            "planned_and_repeated": {
              "every_other_year": "%{planned_year}, sedan vartannat år.",
              "every_year": "%{planned_year}, sedan varje år.",
              "interval": "%{planned_year}, sedan vart %{interval}:e år.",
              "once": "%{planned_year}"
            },
            "previously_repeated": "Genomförd tidigare",
            "price_breakdown": {
              "administration_cost_percentage": "Byggherrekostnader",
              "amount": "Antal",
              "indexation": "Indexering",
              "unit_price": "Styckpris",
              "vat_rate": "Momssats"
            },
            "price_breakdown_label": "Visa prisuppdelning",
            "total_price_excl_vat": "Totalt pris (exkl. moms)",
            "total_price_incl_vat": "Totalt pris (inkl. moms)",
            "unit_price_excl_vat": "Styckpris (exkl. moms)"
          }
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false
        }
      }
    }
  }
}